<template>
  <div class="app ma-4">
    <v-sheet v-show="showSkeletonForm" class="pa-3">
      <v-row v-for="m in 2" :key="`form_relatorio_fila_${m}`">
        <v-col v-for="n in 3" :key="`line_form_1_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-spacer v-for="p in 10" :key="`spacer_${p}`" />
        <v-col>
          <v-skeleton-loader type="button" />
        </v-col>
      </v-row>
    </v-sheet>

    <v-form v-show="!showSkeletonForm">
      <v-row dense>
        <v-col>
          <CalendarWithMultipleAndRange
            label="Dias"
            v-model="dateSelected"
            :date-props="dateProps"
            :text-field-props="textProps"
          />

        </v-col>

        <v-col>
          <ClockRange
            label="Horas"
            min_max="true"
            v-model="timeSelected"
            :time-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
          />

        </v-col>
        <v-col cols="4">
          <v-autocomplete
            multiple
            dense
            outlined
            label="Tipo da Ligação"
            v-model="form.tipos"
            :items="tipos"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.tipos.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleTipos">
                <v-list-item-action>
                  <v-icon
                    :color="form.tipos.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ iconTipos }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-autocomplete
            label="Status"
            outlined
            dense
            v-model="form.status"
            :items="status"
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.status.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleStatus">
                <v-list-item-action>
                  <v-icon
                    :color="form.status.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ iconStatus }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col>
          <v-text-field
            dense
            outlined
            label="Número de Destino"
            hint="7000,7001,7002"
            persistent-hint
            :value="numeroOrigem"
            @change="(v) => (numeroOrigem = v)"
          />
        </v-col>
        <v-col>
          <v-autocomplete
            multiple
            dense
            outlined
            label="Centro de Custo"
            v-model="form.centrosDeCusto"
            :items="centrosDeCusto"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption">
                  (+{{ form.centrosDeCusto.length - 1 }})
                </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleCentroDeCustos">
                <v-list-item-action>
                  <v-icon
                    :color="
                      form.centrosDeCusto.length > 0 ? 'indigo darken-4' : ''
                    "
                  >
                    {{ iconCentroDeCusto }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="4" v-if="!selectByDepartament">
          <v-autocomplete
            v-model="form.operadores"
            :items="operadores"
            outlined
            multiple
            dense
            :label="'Operadores'"
            :error-messages="operadoresErrors"
            @input="$v.form.operadores.$touch()"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption">
                  (+{{ form.operadores.length - 1 }})
                </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="form.operadores.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item ripple @click="toggleOperadoresAtivos">
                <v-list-item-action>
                  <v-icon
                    :color="somenteOperadoresAtivos ? 'indigo darken-4' : ''"
                  >
                    {{ iconOperadoresAtivos }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Operadores Ativos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="4" v-if="selectByDepartament">
          <v-autocomplete
          dense
          outlined
          multiple
          v-model="departamentosSelecionados"
          :items="departamentos"
          label="Departamento"
          :error-messages="departamentoErrors"
          @input="$v.departamentosSelecionados.$touch()">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ departamentosSelecionados.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleDepartamento">
                <v-list-item-action>
                  <v-icon :color="departamentosSelecionados.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconDepartamento }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
          <v-radio-group dense v-model="selectByDepartament" row class="mt-2">
            <v-radio
              label="Departamento"
              color="bluePcm"
              :value="true"
              @change="radioDepartamentoSelecionado"
            />
            <v-radio
              label="Operador"
              color="bluePcm"
              :value="false"
              @change="radioOperadorSelecionado"
            />
            
          </v-radio-group>
        <v-col class="text-right">
          <v-btn color="orangePcm" dark class="mr-2" @click="exportExcel">Exportar Excel</v-btn>
          <v-btn color="bluePcm" dark @click="gerar">Gerar</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="ma-2" />

    <div v-show="showRelatorio">
      <v-sheet v-show="showSkeleton" class="pa-3">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>
      <v-expansion-panels v-model="panel" multiple focusable>
        <v-expansion-panel
          v-for="(operador, key) in listaOperadores"
          :key="key"
        >
          <ExpandListExterno
            v-show="!showSkeleton"
            :operador="operador"
            :form="form"
          />
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div v-for="n in 3" :key="n">
      <v-divider vertical />
    </div>

  </div>
</template>

<script>

import { initialAndFinalDateTextInputReportForm } from "@/mixins/initialAndFinalDateTextInputReportForm";
import relatorioOperadorDetalhadoHttpService from "../_services/relatorioOperadorDetalhadoHttpService"

import { relatoriosOperadorMixins } from "../../../_mixins/relatoriosOperadorMixins";


import ExpandListExterno from "../_components/ExpandListExterno";

import CalendarWithMultipleAndRange from "@/componentes/CalendarWithMultipleAndRange";
import ClockRange from "@/componentes/ClockRange";
import moment from "moment";


export default {
  name: "RelatorioDetalhadoOperador",
  components: { ExpandListExterno, CalendarWithMultipleAndRange, ClockRange },
  mixins: [initialAndFinalDateTextInputReportForm, relatoriosOperadorMixins],
  data: () => ({
    // hideButtons: true,
    // expandir: true,
    showRelatorio: false,
    listaOperadores: [],
    panel: [],
    numeroOrigem: "",
    form: {
      operadores: [],
      numeroOrigem: [],
      status: [],
      centrosDeCusto: [],
      tipos: [],
    },
    status: [
      { text: "Atendidas", value: "atendida" },
      { text: "Não Atendidas", value: "naoAtendida" },
    ],
    tipos: [
      { text: "Ligações de Saída", value: "saida" },
      { text: "Ligações da Fila ao Operador", value: "fila" },
      { text: "Direto ao Operador", value: "direto" },
    ],
    permissaoHistorico: false,
    dateSelected:{},
    timeSelected:{},
  }),

  computed: {
    todosStatusSelecionados() {
      return this.form.status.length === this.status.length;
    },
    algunsStatusSelecionados() {
      return this.form.status.length > 0 && !this.todosStatusSelecionados;
    },
    iconStatus() {
      if (this.todosStatusSelecionados) return "mdi-close-box";
      if (this.algunsStatusSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    todosTiposSelecionados() {
      return this.form.tipos.length === this.tipos.length;
    },
    algunsTiposSelecionados() {
      return this.form.tipos.length > 0 && !this.todosTiposSelecionados;
    },
    iconTipos() {
      if (this.todosTiposSelecionados) return "mdi-close-box";
      if (this.algunsTiposSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    dateTimeRange(){
      return {...this.dateSelected,...this.timeSelected}
    },
  },

  async created() {

    this.toggleStatus()
    this.toggleTipos()

    this.timeSelected = {timeStart: '00:00', timeEnd: '23:59'}
    this.dateSelected = {dateIsRange: true, dates:[moment().format("YYYY-MM-DD")]}


  },

  methods: {
    toggleStatus() {
      this.$nextTick(() => {
        if (this.todosStatusSelecionados) {
          this.form.status.splice(0);
        } else {
          this.form.status.splice(0);
          this.form.status = this.status.map((stat) => stat.value);
        }
      });
    },

    toggleTipos() {
      this.$nextTick(() => {
        if (this.todosTiposSelecionados) {
          this.form.tipos.splice(0);
        } else {
          this.form.tipos.splice(0);
          this.form.tipos = this.tipos.map((tipo) => tipo.value);
        }
      });
    },

    // Comportamento dos radio buttons

    radioDepartamentoSelecionado() {
      this.departamentosSelecionados = [];
      this.showRelatorio = false;
    },
    radioOperadorSelecionado() {
      this.form.operadores = [];
      this.showRelatorio = false;
    },

    // ===

    numeroOrigemFormer(numero) {
      let numeroIntermediario = numero.split(",");
      let numeroArray = [];

      numeroIntermediario.forEach((numeros) => {
        if (numeros.split("-")[1] == undefined) {
          numeroArray.push(numeros);
        } else {
          let inicioRange = numeros.split("-")[0];
          let finalRange = numeros.split("-")[1];
          if (inicioRange > finalRange) {
            window.alert(
              "Início do range não pode ser maior que final do range"
            );
            return;
          } else {
            for (let i = inicioRange; i <= finalRange; i++) {
              numeroArray.push(i.toString());
            }
          }
        }
      });
      return numeroArray;
    },

    gerar() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }

      // Caso outro relatorio tenha sido gerado, fecha itens que estiverem abertos antes de gerar outro
      this.panel.splice(0);
      // =====
      this.showRelatorio = true;
      this.showSkeleton = true;

      this.form.dateTimeRange = this.dateTimeRange;

      this.listaOperadores.splice(0);

      this.form.operadores.forEach((operador) => {
        if(!this.selectByDepartament){
          const indexOperador = this.operadores.findIndex(
            (operadorResponse) => operadorResponse.value === operador
          );

          if (indexOperador !== -1) {
            this.listaOperadores.push({
              dadosOperador: this.operadores[indexOperador],
              podeGerar: true,
            });
          }
        }else{
          const indexOperadores = this.departamentosParaAgents.findIndex(
            (operadorSelect) => operadorSelect.value === operador
          );

          if (indexOperadores !== -1) {
            this.listaOperadores.push({
              dadosOperador: this.departamentosParaAgents[indexOperadores],
              podeGerar: true,
            });
          }

        }
      });



      this.showSkeleton = false;
    },

    async exportExcel() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }
      const params = {
        dateTimeRange: this.dateTimeRange,
        operadores: this.form.operadores,
        numeroOrigem: this.form.numeroOrigem,
        status: this.form.status,
        centrosDeCusto: this.form.centrosDeCusto,
        maiorQue: this.form.maiorQue,
        tipos: this.form.tipos,
      }
      window.open(relatorioOperadorDetalhadoHttpService.exportExcel(params));
    },
  },

  watch: {
    numeroOrigem(novo) {
      this.form.numeroOrigem = this.numeroOrigemFormer(novo);
      if (
        this.form.numeroOrigem[0] === "" &&
        this.form.numeroOrigem.length === 1
      )
        this.form.numeroOrigem.splice(0, 1);
    },
  },
};
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
.fixed-buttons {
  position: fixed;
  right: 0;
  bottom: 0;
  margin-bottom: 30px;
  z-index: 4;
}
.iconeEncolhe {
  margin-top: -3px;
}
.icone {
  margin-top: -5px;
  width: 8px;
}
</style>
